<template>
  <div>
    <h4 class="greenTitle">{{list | len}} | Folios a planificar</h4>
    <el-button-group class="orderMenu">
      <el-button v-show="list"
                 :icon="sortedby.suborder > 0 ? 'fas fa-sort-up':
                 sortedby.suborder < 0 ? 'fas fa-sort-down' : ''"
                 size="small"
                 class="flat"
                 @click="toggleSortSuborder">
        Suborden
      </el-button>
      <el-button v-show="list"
                 :icon="sortedby.locality > 0 ? 'fas fa-sort-up':
                 sortedby.locality < 0 ? 'fas fa-sort-down' : ''"
                 size="small"
                 class="flat"
                 @click="toggleSortLocality">
        Localidad
      </el-button>
      <el-button v-show="list"
                 :icon="sortedby.date > 0 ? 'fas fa-sort-up':
                 sortedby.date < 0 ? 'fas fa-sort-down' : ''"
                 size="small"
                 class="flat"
                 @click="toggleSortDate">
        Fecha
      </el-button>
      <el-button v-show="list"
                 :icon="sortedby.geo ? 'fas fa-filter': 'far fa-circle'"
                 size="small"
                 class="flat"
                 @click="toggleGeoFilter">
        Centroides
      </el-button>
      <el-popover
        placement="bottom"
        class="filterMenu"
        width="400"
        trigger="click">
        <!-- FILTER -->
        <el-row class="filterPopOver">
          <el-col :span="24">
            <h4 class="greenTitle">opciones de filtro</h4>
          </el-col>
          <el-col :span="24">
            <el-form>
              <!-- PackageTypes Filter -->
              <el-form-item
                label="Tipo de paquete">
                <el-select
                  v-model="soc_filters.package_types_id"
                  clearable
                  multiple
                  placeholder="Ej: MMT">
                  <el-option
                    v-for="package_type in getPackageTypes"
                    :key="package_type.id"
                    :label="package_type.type"
                    :value="package_type.id"/>
                </el-select>
              </el-form-item>
              <!-- StateTypes Filter -->
              <el-form-item
                label="Tipo de estado">
                <el-select
                  v-model="soc_filters.state_types_id"
                  clearable
                  multiple
                  placeholder="Ej: Planificado">
                  <el-option
                    v-for="state_type in getStateTypes"
                    :key="state_type.id"
                    :label="state_type.type"
                    :value="state_type.id"/>
                </el-select>
              </el-form-item>
              <!-- Locality Filter -->
              <el-form-item
                label="Localidad">
                <el-select
                  v-model="soc_filters.locality"
                  clearable
                  multiple
                  placeholder="Ej: Maipú">
                  <el-option
                    v-for="locality in getLocalities"
                    :key="locality.id"
                    :label="locality.name"
                    :value="locality.name"/>
                </el-select>
              </el-form-item>
              <!-- Date Filter -->
              <el-form-item
                label="Fecha">
                <el-select
                  v-model="soc_filters.requested_at"
                  clearable
                  multiple
                  placeholder="Ej: 22-01-2019">
                  <el-option
                    v-for="requested in getRequestedAt"
                    :key="requested.id"
                    :label="requested.date"
                    :value="requested.date"/>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-button slot="reference"
                   class="filterMenuBtn flat"
                   icon="fas fa-filter"> Filtros</el-button>
      </el-popover>
    </el-button-group>
    <!-- ListOfSocs -->
    <SocSelector v-model="toDelete"
                 :data="socs"
                 :filterMethod="filterSocs"
                 @removeSoc="deleteEvent"/>
    <!-- DeleteAllSelect-->
    <el-button :icon="'el-icon-delete'"
               class="flat removeAllSocs"
               @click="removeSelected">
      Eliminar seleccionadas
    </el-button>
    <h4 class="greenTitle">Agregar folios</h4>
    <el-input type="textarea"
              id="container"
              style="margin-bottom: 10px;"
              :rows="2"
              placeholder="124005957777, 124005958888, 124005959999 ..."
              v-model="textareaSocs">
    </el-input>
    <transition name="el-zoom-in-top" duration="2">
      <el-button v-show="textareaSocs!==''"
                 class="default"
                 style="margin-bottom: 10px; width: 100%;"
                 @click="verifySocs">CARGAR FOLIOS</el-button>
    </transition>
    <div class="buttonsContainer">
      <el-button  class="flat"
                  @click="handlePrevStep()">
        VOLVER
      </el-button>
      <el-button  v-if="list.length > 0 && !loadingTableDialog"
                  :disabled="verify"
                  class="default"
                  @click="handlePlan()">
        PLANIFICAR
      </el-button>
    </div>
    <el-dialog :visible.sync="dialogFormVisibleTrucks"
               width="600px"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="true">
      <p v-if="loadTransfer" style="margin: 0 0 20px 0 ; color: #F5A623">
        <i class="el-icon-loading" aria-hidden="true"></i>CARGANDO VEHÍCULOS...
      </p>
      <p v-else style="margin: 0 0 20px 0 ;">
        <i class="el-icon-truck" aria-hidden="true"></i>SELECCIONA LOS VEHÍCULOS A PLANIFICAR
      </p>
      <p style="font-size: 11px; color: #b4b4b4;">
        DISPONIBLES {{this.dataVehicles.length}}
      </p>
      <el-transfer
        filterable
        style="margin-top: 15px;"
        v-model="selectedVehicles"
        :titles="['PATENTES ACTIVAS', 'A PLANIFICAR']"
        :data="dataVehicles">
      </el-transfer>
      <p v-if="showActivateVehicle"
         style="margin: 20px 0 10px 0; color: #a5a5a5;">
        <i class="el-icon-warning" aria-hidden="true"></i>NO HAY VEHÍCULOS ACTIVOS PARA EL CT/CD
      </p>
      <span slot="footer" class="dialog-footer">
      <el-button class="dark"
                 style="margin-top: 20px;"
                 @click="handleActivateVehicles">ACTIVAR VEHÍCULOS
      </el-button>
      <el-button class="default"
                 style="margin-top: 20px;"
                 @click="saveSelectVehicle">ACEPTAR
      </el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogTableActivateTrucks"
               width="600px"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="true">
      <p v-if="loadTransfer" style="margin: 0 0 20px 0 ; color: #F5A623">
        <i class="el-icon-loading" aria-hidden="true"></i>CARGANDO VEHÍCULOS...
      </p>
      <p v-else style="margin: 0 0 20px 0 ;">
        <i class="el-icon-truck" aria-hidden="true"></i>ACTIVA LOS VEHÍCULOS PARA PLANIFICAR
      </p>
        <el-form class="form-map-main">
          <el-form-item label="FILTRO POR PATENTE">
            <el-input
              v-model="search"
              size="mini"
              placeholder="PATENTE">
              <template slot="append">{{dataQueryVehicles.filter(
                data => !search || data.patent.toLowerCase()
                .includes(search.toLowerCase())).length}}</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div v-if="dataQueryVehicles.length > 0 || loadingTableDialog === true">
          <el-table
            v-loading="loadingTableDialog"
            :data="dataQueryVehicles.filter(
            data => !search || data.patent.toLowerCase().includes(search.toLowerCase()))"
            height="300px"
            size="mini"
            width="100%">
            <el-table-column
              label="VEHICULO"
              min-width="100">
              <template slot-scope="scope">
                {{scope.row.patent}}
              </template>
            </el-table-column>
            <el-table-column
              label="TIPO"
              min-width="100">
              <template slot-scope="scope">
                {{scope.row.vehicle_type.name}}
              </template>
            </el-table-column>
            <el-table-column label="ACTIVAR"
                             align="center"
                             min-width="75"
                             prop="active" >
              <template slot-scope="scope" align="center">
                <el-switch v-model="scope.row.active"
                           @change="changeActivate(scope.row)">
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="dataQueryVehicles.length === 0 && loadingTableDialog === false">
          <p style="margin: 20px 0 10px 0; color: #a5a5a5;">
            <i class="el-icon-warning" aria-hidden="true"></i>
            NO EXISTEN VEHÍCULOS ASOCIADOS AL {{stepFullData.config.distribution_centers_name[0]}}
          </p>
          <p style="margin: 20px 0 10px 31px; color: #a5a5a5;">DE LA EMPRESA
            {{stepFullData.config.enterprises_name[0]}}. </p>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="default"
                   style="margin-top: 20px;"
                   @click="handlePostActivateVehicles">ACEPTAR
      </el-button>
      </span>
    </el-dialog>
    <h4 style="margin-top: 40px;" class="greenTitle">
      {{this.selectedVehicles.length}} | VEHÍCULOS PARA PLANIFICAR
    </h4>
    <el-button  class="default"
                @click="dialogFormVisibleTrucks = true">MODIFICAR</el-button>
    <div style="margin-top: 50px">
      <h4 class="greenTitle">Guarda tu configuración</h4>
      <el-input
        placeholder="Ingrese Alias de Configuración"
        prefix-icon="el-icon-user"
        v-model="alias"
        maxlength="40"
        show-word-limit>
        <el-button slot="append"
                   icon="el-icon-check"
                   style="color: #AAD500;"
                   @click="saveConfigAlias()">
          GUARDAR
        </el-button>
      </el-input>
    </div>
  </div>
</template>

<script>

import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';
import SocSelector from './planning/SocSelector.vue';

export default {
  components: {
    SocSelector,
  },
  props: {
    stepData: {
      type: Object,
    },
    stepFullData: {
      type: Object,
    },
    notFound: {
      type: Boolean,
      default: true,
    },
    datos: {
      type: Array,
    },
  },
  data() {
    return {
      toDelete: [],
      soc_filters: {
        requested_at: [],
        state_types_id: [],
        package_types_id: [],
        locality: [],
      },
      timeInit: moment(new Date(2016, 9, 10, 9, 0)).format('HH:mm'),
      timeFinish: moment(new Date(2016, 9, 10, 21, 0)).format('HH:mm'),
      data: {
        requested_at: [],
        state_types_id: [],
        package_types_id: [],
        locality: [],
      },
      dataToCheck: {
        package_types_id: [],
        state_types_id: [],
        time_init: '',
        time_finish: '',
      },
      fullStepData: {
        config: {
          package_types_id: [],
          state_types_id: [],
          time_init: '',
          time_finish: '',
        },
      },
      alias: '',
      sortedby: {
        suborder: 0,
        locality: 0,
        date: 0,
        packageTypes: '',
        stateTypes: '',
        geo: false,
      },
      verify: false,
      totalSize: 0,
      planningButton: false,
      textareaSocs: '',
      list: [],
      selectedVehicles: [],
      dataVehicles: [],
      dialogFormVisibleTrucks: true,
      dialogTableActivateTrucks: false,
      loadTransfer: false,
      vehicles: [],
      search: '',
      dataQueryVehicles: [],
      showActivateVehicle: false,
      loadingTableDialog: false,
    };
  },
  filters: {
    len(data) {
      return data.length;
    },
    exists(data) {
      if (data.length > 0) {
        return true;
      }
      return false;
    },
  },
  methods: {
    deleteEvent(soc) {
      this.list = this.list.filter(s => s.suborder.toString() !== soc.toString());
    },
    emulateFilter(soc) {
      this.soc_filters.package_types = 5;
      if (this.soc_filters.package_types) {
        return soc.package_type_id === this.soc_filters.package_types;
      }
      return true;
    },
    removeSelected() {
      // eslint-disable-next-line max-len
      this.list = this.list.filter(s => this.toDelete.findIndex(val => val.toString() === s.suborder.toString()) === -1);
    },
    listData(arr) {
      return arr.join(', ');
    },
    closeDialog() {
      this.dialogFormVisibleTrucks = false;
      this.selectedVehicles = [];
    },
    saveSelectVehicle() {
      if (this.selectedVehicles.length > 0) {
        this.dialogFormVisibleTrucks = false;
        this.$emit('selectedVehicles', this.selectedVehicles);
      } else {
        this.$message({
          title: 'Advertencia',
          message: 'Debe seleccionar al menos un vehículo de la lista',
          type: 'warning',
          duration: 5000,
          showClose: true,
        });
      }
    },
    handleActivateVehicles() {
      this.queryVehicles();
      this.dialogTableActivateTrucks = true;
      this.dialogFormVisibleTrucks = false;
    },
    handlePostActivateVehicles() {
      this.dialogFormVisibleTrucks = true;
      this.dialogTableActivateTrucks = false;
      this.showActivateVehicle = false;
      this.dataVehicles = [];
      this.getVehicles();
    },
    setTimeFormat() {
      this.stepData.time_init = moment(`${this.date}T${this.timeInit}`).toISOString();
      this.stepData.time_finish = moment(`${this.date}T${this.timeFinish}`).toISOString();
      this.fullStepData.config.time_init = this.stepData.time_init;
      this.fullStepData.config.time_finish = this.stepData.time_finish;
    },
    getVehicles() {
      this.loadTransfer = true;
      const param = {
        vehicles_enterprises_id: this.stepFullData.config.enterprises_id[0],
        vehicles_active: true,
        limit: 500,
      };
      apiRequest(
        {
          module: 'crud',
          service: 'get_trucks',
          params: param,
        },
      ).then((resp) => {
        this.loadTransfer = false;
        if (resp.data.length === 0) {
          this.showActivateVehicle = true;
        } else {
          for (let i = 0; i < resp.data.length; i += 1) {
            this.dataVehicles.push({
              key: resp.data[i].id,
              label: resp.data[i].patent,
            });
          }
        }
      }).catch(() => {
        this.loadTransfer = false;
        this.dialogFormVisibleTrucks = false;
        this.$notify({
          title: 'ERROR',
          message: 'Error al obtener vehículos',
          type: 'error',
        });
      });
    },
    handlePrevStep() {
      this.$emit('step', 1);
    },
    handlePlan() {
      if (this.dataVehicles.length === 0) {
        this.$message({
          type: 'warning',
          title: 'ADVERTENCIA',
          message: 'Debe seleccionar al menos un vehículo para planificar',
          duration: 5000,
          showClose: true,
        });
        this.dialogFormVisibleTrucks = true;
      } else {
        this.$emit('plan', this.list);
      }
    },
    validateNumber(number) {
      if (number === undefined || number === null) {
        return true;
      }
      if (/(^[0-9]{6,16}$)/.test(number)) {
        return true;
      }
      return false;
    },
    verifySocs() {
      const onlySocs = [];
      const textArea = this.textareaSocs.trim();
      if (textArea !== '') {
        let orders;
        if (textArea.indexOf(', ') !== -1) {
          orders = textArea.split(', ');
        } else if (textArea.indexOf('\n' !== -1)) {
          orders = textArea.split('\n');
        } else if (textArea.indexOf('\r' !== -1)) {
          orders = textArea.split('\r');
        }
        const socs = this.list.map(val => val.suborder);
        Object.keys(orders.filter(e => e !== '').reduce((acc, a) => { acc[a] = 1; return acc; }, {}))
          .forEach((orderStringNumber) => {
            if (this.validateNumber(orderStringNumber.trim())) {
              const aux = parseInt(orderStringNumber, 10);
              if (!socs.includes(aux)) {
                onlySocs.push(aux);
              }
            }
          });
      }
      this.list = onlySocs
        .map(val => ({ suborder: val, verified: false }))
        .concat(this.list);
      // this.scrollToTop();
      this.verify = true;
      while (onlySocs.length > 0) {
        const partialOnlySocs = onlySocs.splice(0, 500);
        this.verifyPartialSocs(partialOnlySocs);
      }
      this.textareaSocs = '';
    },
    verifyPartialSocs(partialOnlySocs) {
      apiRequest({
        module: 'planning',
        service: 'verify_suborders',
        params: {
          suborders: partialOnlySocs,
        },
      }).then((res) => {
        res.data.forEach((val) => {
          Object.entries(val).forEach(([k, v]) => {
            this.list.find(s => s.suborder === val.suborder)[k] = v;
          });
          this.list.find(s => s.suborder === val.suborder).verified = true;
          this.verify = false;
        });
      }).catch(() => {
        this.list = this.list.filter(s => !partialOnlySocs.includes(s.suborder));
        this.verify = false;
        this.$notify({
          type: 'error',
          title: 'Error al cargas las subordenes',
          message: 'Vuelva a intentarlo más tarde',
        });
      });
    },
    scrollToTop() {
      const container = document.querySelector('.socList');
      container.scrollTop = 0;
    },
    setList() {
      this.list = this.datos;
    },
    saveConfigAlias() {
      if (this.alias.trim() !== '') {
        this.$message({
          message: 'Guardando configuración, espera un momento',
          duration: 8000,
          showClose: true,
        });
        const dataConfig = {
          account_id: 1,
          alias: this.alias,
          config: JSON.stringify(this.stepFullData.config),
        };
        apiRequest(
          {
            module: 'planning',
            service: 'config_planning_create',
            params: dataConfig,
          },
        ).then((res) => {
          this.totalSize = parseInt(res.headers['x-total-count'], 10);
          this.loading = false;
          this.$notify({
            title: 'OK',
            message: 'Configuración Guardada',
            type: 'success',
          });
          // eslint-disable-next-line no-unused-vars
        }).catch(() => {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: 'Problemas al cargar Configuraciones',
          });
        });
      } else {
        this.$message({
          type: 'warning',
          title: 'Advertencia',
          message: 'Ingresa un alias para tu configuración',
        });
      }
    },
    toggleSortSuborder() {
      this.sortedby.locality = 0;
      this.sortedby.date = 0;
      if (this.sortedby.suborder === 0) {
        this.sortedby.suborder = 1;
      } else if (this.sortedby.suborder === 1) {
        this.sortedby.suborder = -1;
      } else {
        this.sortedby.suborder = 0;
      }
    },
    toggleSortDate() {
      this.sortedby.suborder = 0;
      this.sortedby.locality = 0;
      if (this.sortedby.date === 0) {
        this.sortedby.date = 1;
      } else if (this.sortedby.date === 1) {
        this.sortedby.date = -1;
      } else {
        this.sortedby.date = 0;
      }
    },
    toggleSortLocality() {
      this.sortedby.suborder = 0;
      this.sortedby.date = 0;
      if (this.sortedby.locality === 0) {
        this.sortedby.locality = 1;
      } else if (this.sortedby.locality === 1) {
        this.sortedby.locality = -1;
      } else {
        this.sortedby.locality = 0;
      }
    },
    toggleGeoFilter() {
      this.sortedby.geo = !this.sortedby.geo;
    },
    queryVehicles() {
      this.loadingTableDialog = true;
      apiRequest({
        module: 'crud',
        service: 'get_trucks',
        params: {
          vehicles_enterprises_id: this.stepFullData.config.enterprises_id[0],
          limit: 500,
        },
      }).then((res) => {
        this.dataQueryVehicles = res.data;
        this.loadingTableDialog = false;
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al obtener información de vehículos disponibles',
        });
        this.loadingTableDialog = false;
      });
    },
    removeSoc(soc) {
      this.list = this.list.filter(el => el.suborder !== soc);
    },
    removeSelectSocs(socs) {
      const allSocs = socs.filter(el => el.checked === true);
      allSocs.forEach((soc) => {
        this.list = this.list.filter(el => el.item.suborder !== soc.suborder);
      });
    },
    changeActivate(row) {
      const text = ((row.active) ? 'habilitar' : 'deshabilitar');
      this.$confirm(`¿Desea ${text} el vehículo ${row.patent} ?`, 'ADVERTENCIA', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        apiRequest({
          module: 'tracing',
          service: 'toggle_vehicle',
          params: {
            vehicle_id: row.id,
            toggle: row.active,
          },
        }).then((res) => {
          const textNotify = ((row.active) ? 'habilitado' : 'deshabilitado');
          this.$notify({
            type: 'success',
            title: `El vehículo ${row.patent} fue ${textNotify}`,
            message: res.data.message,
          });
        }).catch((error) => {
          const selectedVehicle = this.dataQueryVehicles.find(v => v.id === row.id);
          if (selectedVehicle) selectedVehicle.active = !row.active;
          if (error.response) {
            const message = error.response.status === 500
              ? 'Vuelva a intentarlo más tarde' : error.response.data.message;
            this.$notify({
              type: 'error',
              title: 'Error al cambiar el estado',
              message,
            });
          }
        });
      }).catch(() => {
        const selectedVehicle = this.dataQueryVehicles.find(v => v.id === row.id);
        if (selectedVehicle) selectedVehicle.active = !row.active;
      });
    },
  },
  created() {
    this.getVehicles();
  },
  beforeMount() {
  },
  watch: {
    datos() {
      this.setList();
      if (this.list.length > 0) {
        this.planningButton = true;
      }
    },
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: time => !this.list.slice().reduce((acc, soc) => acc || (
          soc.requested_at ? soc.requested_at.substring(0, 10) === moment(time.getTime()).format('YYYY-MM-DD') : false
        ), false),
      };
    },
    socs() {
      return this.list.slice().sort((a, b) => {
        if (this.sortedby.suborder > 0) {
          return a.suborder - b.suborder;
        }
        if (this.sortedby.suborder < 0) {
          return b.suborder - a.suborder;
        }
        return 0;
      }).sort((a, b) => {
        if (this.sortedby.locality > 0) {
          return a.locality < b.locality ? -1 : 1;
        }
        if (this.sortedby.locality < 0) {
          return b.locality > a.locality ? 1 : -1;
        }
        return 0;
      })
        .sort((a, b) => {
          if (this.sortedby.date > 0) {
            return a.requested_at < b.requested_at ? -1 : 1;
          }
          if (this.sortedby.date < 0) {
            return b.requested_at > a.requested_at ? 1 : -1;
          }
          return 0;
        })
        .filter(el => (this.sortedby.geo ? el.geostate === 4 : true));
    },
    filterSocs() {
      let socValue = [];
      if (this.soc_filters.package_types_id.length > 0) {
        let socPackageType = [];
        this.soc_filters.package_types_id.slice().forEach(
          (packageType) => {
            socPackageType = socPackageType.concat(soc => soc.package_type_id === packageType);
          },
        );
        socValue = socValue
          .concat(soc => socPackageType.reduce((acc, i) => acc || i(soc), false));
      }
      if (this.soc_filters.state_types_id.length > 0) {
        let socStateType = [];
        this.soc_filters.state_types_id.slice().forEach(
          (stateType) => {
            socStateType = socStateType.concat(soc => soc.last_state === stateType);
          },
        );
        socValue = socValue
          .concat(soc => socStateType.reduce((acc, i) => acc || i(soc), false));
      }
      if (this.soc_filters.requested_at.length > 0) {
        let socDate = [];
        this.soc_filters.requested_at.slice().forEach(
          (date) => {
            socDate = socDate
              .concat(soc => soc.requested_at.substring(0, 10) === date);
          },
        );
        socValue = socValue
          .concat(soc => socDate.reduce((acc, i) => acc || i(soc), false));
      }
      if (this.soc_filters.locality.length > 0) {
        let socLocality = [];
        this.soc_filters.locality.slice().forEach(
          (locality) => {
            socLocality = socLocality
              .concat(soc => soc.locality === locality);
          },
        );
        socValue = socValue
          .concat(soc => socLocality.reduce((acc, i) => acc || i(soc), false));
      }
      return soc => socValue.reduce((acc, i) => acc && i(soc), true);
    },
    getStateTypes() {
      return this.list.slice() // this.filterBy.state_types_id
        .filter(e => e.verified)
        .map(pt => ({ id: pt.last_state, type: pt.last_state_name }))
        .filter((pt, i, acum) => acum
          .findIndex(t => t.id === pt.id && pt.id > 0) === i);
    },
    getPackageTypes() {
      return this.list.slice() // this.filterBy.package_types_id
        .filter(e => e.verified)
        .map(pt => ({ id: pt.package_type_id, type: pt.package_type_name }))
        .filter((pt, i, acum) => acum.findIndex(t => t.id === pt.id && pt.id > 0) === i);
    },
    getRequestedAt() {
      return this.list.slice() // this.filterBy.requested_at
        .filter(e => e.verified)
        .map((pt, i) => ({ id: i, date: pt.requested_at.substring(0, 10) }))
        .filter((pt, i, acum) => acum.findIndex(t => t.date === pt.date) === i)
        .sort((a, b) => (b.date < a.date ? -1 : 1));
    },
    getLocalities() {
      return this.list.slice()
        .filter(e => e.verified)
        .map((pt, i) => ({ id: i, name: pt.locality }))
        .filter((pt, i, acum) => acum.findIndex(t => t.name === pt.name) === i)
        .sort((a, b) => (a.name < b.name ? -1 : 1));
    },
  },
};
</script>
<style lang="scss" scoped>
.stepsMaxWidth {
  max-width: 90%;
}
.dialog-footer{
  text-align: right;
}
.grey{
  background-color: $fb-grey-light-30 !important;
  border-color: $fb-grey-light-30 !important;
}
.stepContainerStyle {
  //max-height: 600px;
  //overflow: scroll;
  width: 90%;
  border: 1px solid #E0E0E0;
  margin-top: 1em;
  padding: 1.5em;
  box-sizing: border-box;
}
.timePickerStyle {
  display: flex;
  width: 100%;
  margin-bottom: 22px;
  justify-content: space-between;
  .timePicker {
    width: 48.5%;
  }
}
.el-icon-truck{
  color: #AAD500;
  font-size: 20px;
  margin-right: 10px;
}
.el-icon-loading{
  color: #AAD500;
  font-size: 20px;
  margin-right: 10px;
}
.el-icon-warning{
  color: #F5A623;
  font-size: 20px;
  margin-right: 10px;
}
.buttonsContainer {
  display: flex;
  justify-content: space-between;
}
.confirmationText {
  color:#707070;
  font-size: 16px;
  margin: 0;
  font-weight: 400;
  margin-bottom: 1.4em;
}
.greenTitle{
  font-size: 15px;
  color: #AAD500;
  margin: 0;
  margin-bottom: 20px;
  text-align: left;
  font-weight: 900;
  text-transform: uppercase;
}
.greySubTitle{
  color: #707070;
  font-weight: 300;
  text-align: left;
  font-size: 16px;
  margin: 0 0 1em;
}
.titleStyle {
  font-size: 12px;
  color: #AAD500;
  font-weight: 900;
  text-transform: uppercase;
  margin: 0;
}

.elementStyle {
  font-size: 14px;
  color: #707070;
  font-weight: 300;
  margin: 0 0 1em;
}
.float{
  padding-left: 50%;
  position:fixed;
  width:60px;
  height:60px;
  bottom:40px;
  right:40px;
  background-color:#0C9;
  color:#FFF;
  border-radius:50px;
  text-align:center;
  box-shadow: 2px 2px 3px #999;
}
.my-float{
  margin-top:22px;
}

.orderMenu{
  width: 100%;
  .filterMenu{
    float: right;
    .filterMenuBtn{
    }
  }
}

.removeAllSocs{
  margin: 10px 0 20px;
  width: 100%;
}

.filterPopOver {
  padding: 0 6px;
}

</style>
